<div [formGroup]="parentGroup" class="grid">
  <div class="form-group span-12">
    <label class="label" for="input-native-language">
      <ng-container i18n="@@shared.recipientProfile.input.nativeLanguage">Muttersprache</ng-container>
      <abbr class="req-label" i18n-title="@@main.alt.required" title="Pflicht">*</abbr>
    </label>
    <ng-select [clearable]="false"
      [items]="availableLanguages"
      appAddIconChevronDown
      bindLabel="name"
      bindValue="key"
      formControlName="nativeLanguage"
      i18n-placeholder="@@shared.recipientProfile.placeholder.nativeLanguage"
      labelForId="input-native-language"
      placeholder="Auswählen...">
    </ng-select>
    @if (nativeLanguageControl.invalid && (nativeLanguageControl.touched || nativeLanguageControl.dirty)) {
      <div
        class="validation error"
        class="validation error" i18n="@@shared.recipientProfile.error.nativeLanguage">Bitte wählen Sie Ihre
            Muttersprache aus.
        </div>
    }
  </div>

  <!-- <app-toglle-visibility [form]="form"></app-toglle-visibility> -->

  <div class="span-12">
    <div class="form-group ">
      <label class="label" for="input-languages" i18n="@@shared.recipientProfile.input.otherLanguages">Weitere
                Sprachen</label>
      <ng-select [clearable]="false"
        [formControl]="addSelectedLanguageControl"
        [items]="availableLanguages"
        appAddIconChevronDown
        bindLabel="name"
        i18n-placeholder="@@shared.recipientProfile.placeholder.otherLanguages"
        labelForId="input-languages"
        placeholder="Hinzufügen...">
      </ng-select>
    </div>

    <div class="form-group">
      <app-tag-selector (valueChange)="languagesControl.setValue($event); languagesControl.markAsDirty();"
        [selectableTags]="favoriteLanguages"
        [value]="languagesControl.value"
        labelledby="input-assistance-services">
      </app-tag-selector>
    </div>
  </div>

  <div class="form-group span-6">
    <label class="label" for="input-phone" i18n="@@shared.recipientProfile.input.telefon">Telefon (optional)</label>
    <input class="input" formControlName="phone" id="input-phone" inputmode="tel" maxlength="20" type="text">
    @if (phone.invalid && (phone.touched || phone.dirty)) {
      <div
        class="validation error" i18n="@@shared.recipientProfile.error.telefon">Bitte geben Sie eine gültige
            Telefonnummer ein.
        </div>
    }
  </div>

  @if (birthdateControl) {
    <div class="form-group span-6">
      <app-date-selector
        (valueChange)="birthdateControl.setValue($event); birthdateControl.markAsDirty();"
        [valueControl]="birthdateControl"
      ></app-date-selector>
    </div>
  }

  <div class="form-group span-12">
    <label class="label" id="input-gender">
      <ng-container i18n="@@shared.recipientProfile.input.gender">Geschlecht</ng-container>
      <abbr class="req-label" i18n-title="@@main.alt.required" title="Pflicht">*</abbr>
    </label>
    <app-segment-button-list (valueChange)="genderControl.setValue($event); genderControl.markAsDirty();"
      [selectableTags]="availableGenders$ | async"
      [value]="genderControl.value"
      labelledby="input-gender">
    </app-segment-button-list>
  </div>

  <div class="form-group span-12">
    <label class="label" i18n="@@shared.recipientProfile.input.mobility" id="input-mobility">Ich verfüge über
            folgende Mobilitätsmöglichkeiten (optional)</label>
    <app-tag-selector (valueChange)="mobilityControl.setValue($event); mobilityControl.markAsDirty();"
      [selectableTags]="availableMobility$ | async"
      [value]="mobilityControl.value"
      labelledby="input-mobility">
    </app-tag-selector>
  </div>

  <div class="form-group span-12 upload-tool">
    <!-- id is linked in .ts file -->
    <label class="label" for="input-documents" i18n="@@shared.recipientProfile.title.documents">Dokumente wie
            Stellenbeschreibung, Inserate, etc. (optional)</label>

    @for (doc of visibleDocuments; track doc) {
      <div class="document">
        <div class="border">
          <a (click)="downloadDocument(doc, $event)" [href]="documentUrl(doc)" class="filename">{{ doc.name }}</a>
        </div>
        <button (click)="removeDocument(doc)" class="button form icon-only small">
          <span aria-hidden="true" class="icon icon-trash"></span>
          <span class="sr-only" i18n="sr-only@@shared.recipientProfile.btn.removeDocument">Entfernen</span>
        </button>
      </div>
    }
    <form #myForm enctype="multipart/form-data" method="post">

      <div class="mobile-input">
        <input (change)="onChange($event)" class="mobile-input--input" id="mobile-input" multiple type="file"/>
        <div class="filepond--drop-label">
          <label aria-hidden="true" for="mobile-input" i18n="@@shared.recipientProfile.input.documents">
                        Dateien hier hinziehen oder <span class="filepond--link">auswählen</span>
                        <br>
                        <span class="info">Maximal 10 MB pro Datei</span>
                        <span aria-hidden="true" class="icon icon-arrow-up-circle"></span>
                    </label>
          </div>
        </div>

        <file-pond #myPond [options]="pondOptions"></file-pond>
      </form>

      @if (documentsControl.touched && documentsControl.errors && documentsControl.errors.uploading) {
        <div
          class="validation error" i18n="@@shared.recipientProfile.error.documents">Solange der Upload läuft, kann
            mit der Registrierung nicht fortgefahren werden.
        </div>
      }
    </div>
  </div>
